import { type Me, ME_PATH, meSchema } from '@baby-tracker/contracts';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiGet } from '../lib/api-client.js';
import { queryKeys } from '../lib/query-keys.js';

export function useMe(): UseQueryResult<Me> {
    return useQuery({
        queryKey: queryKeys.me,
        queryFn: ({ signal }) => apiGet(ME_PATH, meSchema, { signal }),
    });
}
